export const PASSWORD_RULES = 'At least 10 characters, with upper and lower case letters and a number.';

/**
 * Readable messages for Cognito's password errors (forgot / change password).
 * `overrides` replaces the message for an error name whose meaning depends on
 * the flow, e.g. NotAuthorizedException.
 */
export function passwordErrorMessage(err: unknown, fallback: string, overrides: Record<string, string> = {}): string {
  if (!(err instanceof Error)) return fallback;
  if (overrides[err.name]) return overrides[err.name]!;
  switch (err.name) {
    case 'UserNotFoundException':
      return 'There’s no account with that email. Check the spelling, or ask a unit admin for an invite.';
    case 'CodeMismatchException':
      return 'That code isn’t right — check the latest email and try again.';
    case 'ExpiredCodeException':
      return 'That code has expired. Send a new code and use the latest one.';
    case 'InvalidPasswordException':
      return `That password isn’t allowed. ${PASSWORD_RULES}`;
    case 'LimitExceededException':
    case 'TooManyRequestsException':
    case 'TooManyFailedAttemptsException':
      return 'Too many attempts — wait a few minutes and try again.';
    case 'CodeDeliveryFailureException':
      return 'We couldn’t send the code email. Try again shortly, or ask a unit admin to reset your sign-in.';
    default:
      return err.message || fallback;
  }
}
